// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_m6-0";
export var animationContainer = "_m6-1";
export var itemPrice = "_m6-a";
export var itemizedContent = "_m6-9";
export var itemizedHeader = "_m6-7";
export var itemizedRow = "_m6-8";
export var itemizedSection = "_m6-6";
export var modalContent = "_m6-2";
export var orderName = "_m6-3";
export var refundOption = "_m6-4";
export var refundOptionsContainer = "_m6-5";
export var shippingLabel = "_m6-b";
export var totalRow = "_m6-c";